import { Link, Navigate, useParams } from 'react-router-dom'
import { Icon } from '../components/Icon'
import { ReferenceFrame } from '../components/ReferenceFrame'

const references: Record<string, { title: string; description: string; src: string }> = {
  glossary: { title: 'Glossary', description: 'Plain-language definitions for investing, tax, retirement, estate, and planning terms.', src: '/course/glossary.html' },
  tools: { title: 'Tools & Calculators', description: 'Use the course calculators and worksheets without creating an account.', src: '/course/tools.html' },
  resources: { title: 'Resources', description: 'Primary sources, official references, and carefully selected material for further learning.', src: '/course/resources.html' },
}

export function ReferencePage() {
  const { type } = useParams()
  const item = type ? references[type] : null
  if (!item) return <Navigate to="/" replace />
  return (
    <div className="page-width page-stack">
      <nav className="breadcrumbs"><Link to="/">Home</Link><Icon name="chevron" size={14} /><span>{item.title}</span></nav>
      <section className="reference-heading"><span className="eyebrow">Course reference</span><h1>{item.title}</h1><p>{item.description}</p></section>
      <ReferenceFrame src={item.src} title={item.title} />
    </div>
  )
}
